import React from 'react';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import { get, isEmpty, forEach, uniqBy, size } from 'lodash';
import { getLabelWithParam, getLabelWithComponent } from './utils';

const getLink = (link = []) => {
  const content = [];
  if (!isEmpty(link)) {
    forEach(link, value => {
      const { text, url, target = '_self', onClick = '#' } = value;
      content.push(
        <Anchor to={url} handleLinkClick={onClick} target={target}>
          {text}
        </Anchor>
      );
    });
  }
  return content;
};

export const getErrorResponse = (errorResponse, labels) => {
  const id = get(errorResponse, 'id', '');
  const link = get(errorResponse, 'link', []);
  const errorResponseCode = get(errorResponse, 'code', '');
  if (errorResponseCode) {
    if (labels[`${errorResponseCode}_title`]) {
      return {
        title: labels[`${errorResponseCode}_title`],
        description: labels[`${errorResponseCode}_description`],
      };
    }
    if (labels[errorResponseCode] && !isEmpty(link)) {
      const linkData = getLink(link);
      return {
        title: getLabelWithComponent(labels[errorResponseCode], linkData),
      };
    }
    if (labels[errorResponseCode]) {
      return {
        title: getLabelWithParam(labels[errorResponseCode], [id]),
      };
    }
    return {
      title: labels.genericError_title,
      description: labels.genericError_description,
    };
  }
  return { title: '', description: '' };
};

// Get error title and description from error code received from
// failed api Response
const getErrorMessage = (error = [], labels = {}) => {
  let result = [];
  forEach(error, value => {
    const page = get(value, 'page', '');
    if (page === window.location.pathname) {
      const data = getErrorResponse(value, labels);
      result.push(data);
    }
  });
  if (size(result) > 0) {
    result = uniqBy(result, 'title');
  }
  return result;
};

export default getErrorMessage;
